// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_-HFfH","active":"index_active_dMLk5"};